export const AT_SET_ACTION = 'TABS_MODEL_SET_ACTION';
export const AT_REMOVE_TABS_ACTION = 'TABS_MODEL_REMOVE_TABS_ACTION';
